import { login, logout } from '@/api/user'
import router, { constantRoutes,page404Routes } from '@/router'
import { getMapRoutes,routesToTree } from '@/router/asyncRoutes'
import {getUserInfo,setUserInfo,removeUserInfo,setPrimissionMenu,getPrimissionMenu,removePrimissionMenu,setPrimissionBtn,getPrimissionBtn,removePrimissionBtn,getToken, setToken, removeToken} from '@/store/auth'

const state = {
  token: getToken(),
  userInfo: {},
  uploadImg: '/api/file/upload',
  btns: '',
  routes: [],
  addRoutes: [],
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_USERINfO: (state, userInfo) => {
    state.userInfo = userInfo
  },
  SET_ROUTES: (state, routes) => {
    state.addRoutes = routes
    state.routes = constantRoutes.concat(routes)
  },
  SAVE_BTN: (state, btns) => {
    state.btns = btns
  }
}

const actions = {
  login({ commit }, userInfo) {
    const { account, password,code } = userInfo
    return new Promise((resolve, reject) => {
      login({ account: account.trim(), password: password,code: code }).then(response => {

        let { menuList,buttonList,platAdmin,_t } = response.data;
        menuList.push(page404Routes)
        const pRoutes = JSON.stringify(menuList);
        const serviceRouter = routesToTree(getMapRoutes(menuList));
        let btns
        if(buttonList.length>0){
          btns = buttonList.map(item => {
            return item.perms
          }).join(",");
        }else{
          btns = "product:list,shop:save";
        }

        router.$addRoutes(serviceRouter)
        commit('SET_ROUTES', serviceRouter)
        commit('SET_USERINfO', platAdmin)
        commit('SAVE_BTN',btns)
        commit('SET_TOKEN', _t)
        // setToken(_t)

        setUserInfo(JSON.stringify(platAdmin))
        setPrimissionMenu(pRoutes);
        setPrimissionBtn(btns);
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  getPermissionRoutes({ commit }){
    return new Promise(resolve => {
      const btns = getPrimissionBtn()
      const userInfo = JSON.parse(getUserInfo())
      const menuList = JSON.parse(getPrimissionMenu())
      const serviceRouter = routesToTree(getMapRoutes(menuList))

      commit('SET_ROUTES', serviceRouter)
      commit('SET_USERINfO', userInfo)
      commit('SAVE_BTN',btns)
      resolve(serviceRouter)
    })
  },
  setRoutersTest({ commit},routers){
    return new Promise(resolve => {
      commit('SET_ROUTES', routers)
      const pRoutes = JSON.stringify(routers);

      setPrimissionMenu(pRoutes);

      resolve()
    })
  },

  // user logout
  logout({ commit, state, dispatch }) {
    return new Promise((resolve, reject) => {
      logout(state.token).then(() => {
        router.$addRoutes([])
        commit('SET_ROUTES', [])
        commit('SET_USERINfO', null)
        removeToken()
        removeUserInfo();
        removePrimissionMenu();
        removePrimissionBtn();
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js